// Texty stránky Doprava a platba (shippingPage.js), slovenské dvojče. Čísla
// (pásma, ceny, cut-off, dopravci) jdou z modelu parametry.
import { NBSP } from '../../modules/money.js';

const KG = NBSP + 'kg';
// piatková uzávierka ako dovetok („ (v piatok do 14:30)"); s rovnakým časom nič
const friNote = (v) => (v.cutoffFri === v.cutoff ? '' : ' (v piatok do ' + v.cutoffFri + ')');

// SK má hmotnostný tarif ako CZ (pásma, doprava zadarmo na výdajné miesto),
// ale bez osobného odberu a bez víkendových zvozov (manifest `pickup: false`,
// `fastRules: []`, S4 #400) — vety o nich tu nie sú.
export default {
  eyebrow: 'Doručenie a platba',
  perex: (v) =>
    'Cena dopravy sa riadi hmotnosťou zásielky v troch pásmach po ' +
    v.maxKg +
    KG +
    '. Ľahké balíky nad ' +
    v.freeFrom +
    ' vezieme ' +
    v.scope +
    ' zadarmo a objednávky do ' +
    v.cutoff +
    friNote(v) +
    ' odosielame ešte v ten deň.',
  facts: (v) => [
    'Doprava od ' + v.fromPrice,
    'Zadarmo ' + v.scope + ' nad ' + v.freeFrom + ' do ' + v.maxKg + KG,
    'Do ' + v.cutoff + friNote(v) + ' objednáte, dnes odošleme',
    'Nad ' + v.overKg + KG + ' Fofr za ' + v.overPrice,
  ],

  calcTitle: 'Koľko zaplatíte za dopravu',
  calcHint: 'Rovnaký ukazovateľ pásiem uvidíte aj v košíku pri výbere dopravy',
  calcWeightLabel: 'Koľko váži zásielka?',
  calcWeightHint: 'Hmotnosť je pri každom produkte v parametroch; v košíku sa položky sčítavajú.',
  calcValueLabel: 'Hodnota objednávky',
  calcUnder: (freeFrom) => 'do ' + freeFrom,
  calcOver: (freeFrom) => 'nad ' + freeFrom,

  priceTitle: 'Cenník podľa pásiem',
  priceLead: (v) =>
    'Pásma sú uzavreté zdola, otvorené zhora: presne ' +
    v.maxKgDec +
    KG +
    ' už patrí do pásma ' +
    v.maxKg +
    '–' +
    v.nextKg +
    KG +
    '. Rozhoduje súčet hmotností položiek v košíku. Ceny sú s DPH a platia pre celé Slovensko.',
  priceSub: 'výdajné miesto / adresa',
  priceSubLimited: 'výdajné miesto (len PPL) / adresa',
  priceSubOver: 'len Fofr, na adresu',
  priceFreeSum: (freeFrom) => 'nad ' + freeFrom + ' výdajné miesto zadarmo',
  priceFreeCell: (freeFrom) => 'zadarmo nad ' + freeFrom,
  priceMethod: 'Spôsob',
  priceNote: (v) =>
    'Doprava zadarmo platí len v pásme do ' +
    v.maxKg +
    KG +
    ' a len ' +
    v.scope +
    '. Zásielky nad ' +
    v.overKg +
    KG +
    ' vezie len Fofr; tovar nad limity dopravcov ide na palete a cenu vypočítame individuálne.',
  free: 'Zadarmo',
  bandUpTo: 'do ',
  bandOver: 'nad ',
  cellLimit: (kg) => 'len do ' + kg + KG,
  cellOver: (kg) => 'nad ' + kg + KG + ' nevezie',
  cellPromo: (until) => 'akcia do ' + until,
  sumPromo: (carrier, price, until) => carrier + ' ' + price + ' do ' + until,
  heroPromo: (carrier, price, maxKg, until) =>
    'Akcia do ' + until + ': ' + carrier + ' na výdajné miesto za ' + price + ' pri zásielkach do ' + maxKg + KG + '.',
  mergeSuffix: ' a GLS',

  etaTitle: 'Kedy balík dorazí',
  etaHint: (v) =>
    'Tovar skladom, uzávierka expedície ' +
    v.cutoff +
    (v.cutoffFri === v.cutoff ? '' : ', v piatok ' + v.cutoffFri) +
    ' · termín doručenia vidíte pri produkte aj v košíku',
  weekDays: ['Št', 'Pi', 'So', 'Ne', 'Po', 'Ut'],
  dispatch: (cutoff) => 'expedujeme do ' + cutoff,
  dispatchFri: (v) => 'expedujeme do ' + v.cutoff + (v.cutoffFri === v.cutoff ? '' : ', v piatok do ' + v.cutoffFri),
  weekend: 'víkend – neexpedujeme',
  rowStock: 'Sklad',
  rowSat: 'sobota',
  rowSun: 'nedeľa',
  satOrder: 'objednáte',
  satShip: 'odošleme',
  satDeliver: 'doručíme v sobotu',
  satDeliverShort: 'sobota',
  sunOrder: 'objednáte do sobotnej polnoci',
  sunShip: 'zvoz v nedeľu',
  sunShipShort: 'zvoz',
  sunDeliver: 'doručíme v pondelok',
  sunDeliverShort: 'pondelok',
  others: 'ostatní dopravcovia',
  othersShort: 'ostatní',
  legend: ['expedícia skladu', 'objednáte', 'odošleme', 'doručíme'],

  schedHead: ['Objednáte', 'Odošleme', 'Doručíme'],
  schedRows: (v) => [
    // SK doručenie nasledujúci deň nezaručuje (manifest `shipping.deliverySpanDays: 1`,
    // zadanie Tomáša 2026-09-29): lehota je rozmedzie dvoch pracovných dní od odoslania,
    // od 2. pracovného dňa (`shipping.deliveryStartDays: 2`, #572 V1 14. 10. 2026)
    {
      when: v.cutoffFri === v.cutoff ? 'Po–Pi do ' + v.cutoff : 'Po–Št do ' + v.cutoff + ', Pi do ' + v.cutoffFri,
      ship: 'ešte dnes',
      eta: 'za 2–3 pracovné dni',
    },
    { when: 'Po–St po ' + v.cutoff, ship: 'ďalší pracovný deň', eta: 'za 2–3 pracovné dni' },
    {
      when: 'Št ' + v.cutoff + ' – Pi ' + v.cutoffFri,
      fast: 'sat',
      whenNote: v.sat + ' na adresu aj na výdajné miesto',
      ship: 'v piatok',
      eta: 'v sobotu s ' + v.sat,
      etaFast: true,
      etaNote: 'ostatní dopravcovia v pondelok',
    },
    {
      when: 'Pi ' + v.cutoffFri + ' – So 24:00',
      fast: 'sun',
      whenNote: v.sun + ' na adresu aj na výdajné miesto',
      ship: 'v nedeľu s ' + v.sun,
      shipNote: 'ostatní dopravcovia v pondelok',
      eta: 'v pondelok s ' + v.sun,
      etaFast: true,
      etaNote: 'ostatní dopravcovia v utorok',
    },
    { when: 'Nedeľa', ship: 'v pondelok', eta: 'za 2–3 pracovné dni' },
  ],
  // SK nemá sobotný zvoz GLS ani nedeľný zvoz PPL (manifest `shipping.fastRules: []`,
  // S4 #400) — veta o nich by klamala, ostatné pravidlá platia
  schedNote:
    'Platí pre tovar skladom; sviatky sa do expedície nezapočítavajú. Lehota doručenia sa ' +
    'počíta od odoslania. Tovar, ktorý nie je skladom, má termín uvedený na detaile produktu.',
  schedPreShip: 'odošleme ',
  schedPreEta: 'doručíme ',

  carriersTitle: 'Dopravcovia a odber',
  limits: (box, last) => 'výdajné miesta do ' + box + KG + ', adresa do ' + last + KG,
  limitsOver: (last) => 'nad ' + last + KG + ', len na adresu',
  glsText: [
    'Tisíce výdajných miest a GLS boxov po celom Slovensku. V deň prevzatia od nás príde SMS ' +
      's číslom zásielky, ',
    { b: 'kuriér na adresu v deň doručenia volá' },
    '.',
  ],
  pplText: [
    'Parcelshopy a Parcelboxy vrátane boxov tretích strán. ',
    { b: 'Dobierku' },
    ' je na niektorých výdajných miestach PPL možné zaplatiť len cez aplikáciu PPL.',
  ],
  fofrText: (last, price) => [
    'Nadmerné balíky nad ' +
      last +
      KG +
      ' za ' +
      price +
      '. Výdajné miesta ani bežná doprava sa pri nich neponúkajú, košík spôsob zvolí sám. ' +
      'Tovar nad limity dopravcov ide na palete – cenu vypočítame individuálne a ozveme ' +
      'sa hneď po prijatí objednávky.',
  ],
  pickupName: 'Osobný odber',
  pickupFree: 'zadarmo',
  pickupText: (place, hours) => [
    'Predajňa Jipos, ',
    { b: place },
    ' · ' +
      hours +
      '. Tovar skladom máme v predajni pripravený na okamžitý odber.',
  ],

  payTitle: 'Platba',
  payHint: 'Spoplatnená je len dobierka',
  payments: [
    {
      name: 'Kartou online',
      desc:
        'Visa, Mastercard, Apple Pay, Google Pay · tovar skladom expedujeme hneď',
    },
    {
      name: 'Bankovým prevodom / QR platbou',
      desc: 'údaje vrátane QR kódu pošleme po objednávke, odosielame po pripísaní sumy',
    },
    {
      name: 'Dobierkou',
      desc:
        'pri prevzatí kuriérovi alebo na výdajnom mieste; niektoré výdajné miesta PPL len ' +
        'cez aplikáciu PPL',
    },
    { name: 'V hotovosti alebo kartou v predajni', desc: 'pri osobnom odbere v Bíline' },
  ],

  contactTitle: 'Neviete si rady s dopravou ťažkého alebo rozmerného tovaru?',
  contactText:
    'Napíšte nám alebo zavolajte, odporučíme dopravu podľa hmotnosti a rozmerov ' +
    'a pri paletách vypočítame cenu vopred.',
  contactTextNoPhone:
    'Napíšte nám, odporučíme dopravu podľa hmotnosti a rozmerov ' +
    'a pri paletách vypočítame cenu vopred.',
};
